import { FC } from 'react';
import { AdvancedFiltersContainer } from 'shared/containers/AdvancedFiltersContainer';
import { BedroomsContainer } from 'shared/containers/BedroomsContainer';
import { BedsContainer } from 'shared/containers/BedsContainer';
import { BusinessAppointmentsContainer } from 'shared/containers/BusinessAppointmentsContainer';
import { ContractContainer } from 'shared/containers/ContractContainer';
import { DatesContainer } from 'shared/containers/DatesContainer';
import { DealTypeContainer } from 'shared/containers/DealTypeContainer';
import { EarlyAccessContainer } from 'shared/containers/EalryAccessContainer';
import { GeoSuggestContainer } from 'shared/containers/GeoSuggestContainer';
import { MortgagePaymentContainer } from 'shared/containers/MortgagePaymentContainer';
import { OfferTypeContainer } from 'shared/containers/OfferTypeContainer';
import { PriceContainer } from 'shared/containers/PriceContainer';
import { PriceTypeContainer } from 'shared/containers/PriceTypeContainer';
import { RoomTypeContainer } from 'shared/containers/RoomTypeContainer';
import { SpecialtyTypesContainer } from 'shared/containers/SpecialtyTypesContainer';
import { StarRatingContainer } from 'shared/containers/StarRatingContainer';
import { SuburbanAreaContainer } from 'shared/containers/SuburbanAreaContainer';
import { TotalAreaContainer } from 'shared/containers/TotalAreaContainer';
import { WorkplaceCountContainer } from 'shared/containers/WorkplaceCountContainer';
import { WorkplaceTypeContainer } from 'shared/containers/WorkplaceTypeContainer';
import { IsByCommercialOwnerContainer } from 'shared/containers/IsByCommercialOwnerContainer';
import { BusinessAppointmentsCategoryContainer } from 'shared/containers/BusinessAppointmentsCategoryContainer';
import { TFilter } from 'shared/types/filters';

export const FILTERS_MAP: Record<TFilter, FC> = {
  dealType: DealTypeContainer,
  offerType: OfferTypeContainer,
  bedrooms: BedroomsContainer,
  beds: BedsContainer,
  dates: DatesContainer,
  geo: GeoSuggestContainer,
  price: PriceContainer,
  priceType: PriceTypeContainer,
  roomType: RoomTypeContainer,
  suburbanArea: SuburbanAreaContainer,
  starRating: StarRatingContainer,
  advancedFilters: AdvancedFiltersContainer,
  earlyAccess: EarlyAccessContainer,
  mortgageMonthlyPayment: MortgagePaymentContainer,
  totalArea: TotalAreaContainer,
  workplaceCount: WorkplaceCountContainer,
  workplaceType: WorkplaceTypeContainer,
  readyBusinessTypes: BusinessAppointmentsContainer,
  specialtyTypes: SpecialtyTypesContainer,
  businessAppointmentsCategory: BusinessAppointmentsCategoryContainer,
  contract: ContractContainer,
  isByCommercialOwner: IsByCommercialOwnerContainer,
};
